import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ListConstraints from './ListConstraints';
import ConstraintForm from './ConstraintForm';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import DocsLink from '../../../../common/custom/DocsLink';
import ParentDocCard from '../../../common/ParentDocCard';
export default class CustomConstraints extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    constraints: PropTypes.array.isRequired,
    collection: PropTypes.object.isRequired,
  };
  handleSubmit = (values) => {
    const { projectId, collection, version } = this.props;
    this.props.actions.createCollectionConstraint({
      projectId,
      version,
      collectionUuid: collection.uuid,
      data: values,
    });
  };
  showCompositeKeyForm = () => {
    const {
      constraints,
      projectId,
      collection,
      actions,
      showConstraintDeleteLoader,
      showDerivedConstraintLoader,
    } = this.props;
    if (!constraints.find((constraint) => constraint.constraintType === 'COMPOSITE')) {
      return (
        <ConstraintForm
          collection={collection}
          handleSubmit={this.handleSubmit}
          showDerivedConstraintLoader={showDerivedConstraintLoader}
          isCollection={false}
        />
      );
    }
  };
  render() {
    const {
      constraints,
      projectId,
      collection,
      version,
      actions,
      showConstraintDeleteLoader,
      showDerivedConstraintLoader,
      deleteFlag,
    } = this.props;
    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title mb-0 pb-0">
                    Add Constraint{' '}
                    {typeof collection !== 'undefined' && collection
                      ? ' To ' + collection.collectionTitle
                      : ''}
                  </h5>

                  <p>Allows you to restrain data from getting repeated.</p>
                  {this.showCompositeKeyForm()}
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Constraints</h5>
                  <ListConstraints
                    constraints={constraints}
                    projectId={projectId}
                    version={version}
                    collection={collection}
                    actions={actions}
                    showDerivedConstraintLoader={showDerivedConstraintLoader}
                    showConstraintDeleteLoader={showConstraintDeleteLoader}
                    deleteFlag={deleteFlag}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Constraints</b>
          </h5>
          <p>
            Allows you to put restraint on a collection field so that data added or submitted
            through that field does not get repeated. In short it helps you avoid data duplicacy.
            from getting repeated.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/constraints-in-collection" />
        </ParentDocCard>
      </div>
    );
  }
}
